import React from 'react';
import loader from './inproloader.gif';

const InproLoader = () => {
  return (
    <div className="inproloader">
      <img src={loader} />
    </div>
  );
};

export default InproLoader;
